package link.erpango.quip.utils

class WasmPlatform : Platform {
    override val name: String = "Web with Kotlin/Wasm"
    override fun isIOS(): Boolean = false
}

actual fun getPlatform(): Platform = WasmPlatform()
